<template>
  <div class="ag-courses_item">
    <div class="ag-courses-item_link">
      <div class="ag-courses-item_left">
        <div class="ag-courses-item_title">
          {{ getStudentName }}
        </div>

        <div class="ag-courses-item_title">
          {{ getStatus }} | {{ getIntake }}
          <div :class="getRowClass"></div>
        </div>
      </div>

      <div class="ag-courses-item__right">
        <div class="ag-courses-item_date-box">
          Created:
          <span class="ag-courses-item_date">
            {{ createdAt }}
          </span>
        </div>

        <div class="ag-courses-item_date-box">
          Updated:
          <span class="ag-courses-item_date">
            {{ lastUpdate }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { statusOptionsClasses } from '../../models/static';
import moment from 'moment';

export default {
  name: 'bubble',
  props: ['application'],
  data() {
    return {};
  },
  mounted() {},
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    getRowClass() {
      let rowClass = '';
      if (this.application.isApproved) {
        rowClass =
          this.application.status &&
          !statusOptionsClasses[this.application.status]
            ? 'status-nude'
            : statusOptionsClasses[this.application.status];
      } else if (this.application.isDraft) {
        rowClass = 'is_draft';
      } else {
        rowClass = `status-not-approved`;
      }

      return `ag-courses-item_bg ${rowClass}`;
    },
    lastUpdate() {
      return this.application.updatedAt
        ? moment(this.application.updatedAt).format('LLL')
        : 'Invalid Date';
    },
    createdAt() {
      return this.application.createdAt
        ? moment(this.application.createdAt).format('LLL')
        : 'Invalid Date';
    },
    getStatus() {
      return this.application.status && this.application.isApproved
        ? this.application.status
        : this.application.isDraft
        ? 'Draft'
        : 'Not approved';
    },
    getStudentName() {
      return this.application.studentName
        ? this.application.studentName
        : 'Invalid student';
    },
    getIntake() {
      return this.application.intake ? this.application.intake : 'No intake';
    },
  },
  methods: {
    studentName(student) {
      return student.title + ' ' + student.first_name + ' ' + student.last_name;
    },
  },
};
</script>

<style>
.ag-courses_item {
  /* -ms-flex-preferred-size: calc(33.33333% - 30px);
  flex-basis: calc(33.33333% - 30px); */
  border: 1px solid rgba(19, 24, 44, 0.125);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: hidden;

  border-radius: 28px;
}

.ag-courses-item_link {
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 12px;

  overflow: hidden;

  position: relative;
}

.ag-courses-item_title {
  font-weight: bold;
  font-size: 16px;
  color: #5e676f;

  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-box;
  /* max-width: 200px; */
}

.ag-courses-item_date-box {
  font-size: 14px;
  color: #5e676f;

  z-index: 2;
  position: relative;
}

.ag-courses-item_date {
  font-weight: bold;
  color: #8d3217;
}

.ag-courses-item_bg {
  height: 14px;
  width: 14px;
  background-color: #8d3217;
  display: inline-block;
  border-radius: 50%;
}
</style>
